import { render, staticRenderFns } from "./subPc.vue?vue&type=template&id=2780caf9"
import script from "./subPc.vue?vue&type=script&lang=js"
export * from "./subPc.vue?vue&type=script&lang=js"
import style0 from "./subPc.vue?vue&type=style&index=0&id=2780caf9&prod&lang=less"
import style1 from "./subPc.vue?vue&type=style&index=1&id=2780caf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports